export default {
    addText: 'Add image(s) or video(s) (max 12MB)',
    dropText: 'Drop image(s) or video(s) (max 12MB)',
    addImageText: 'Add image(s) (max 12MB)',
    dropImageText: 'Drop image(s) (max 12MB)',
    removeFile: 'Remove file',
    preview: 'Preview'
}
